import React from 'react';
import styled from 'styled-components';
import { SelectedFeedback } from '../../NPOFeedback/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';

interface FeedbackTooltipProps {
  index: number;
  isRejected: boolean;
  isResolved: boolean;
  section: SelectedFeedback;
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACERS.extraTiny};
`;

const FeedbackTooltip: React.FC<FeedbackTooltipProps> = ({
  section,
  isResolved,
  isRejected,
}) => {
  return (
    <StyledDiv>
      <FontAwesomeIcon
        color={
          isResolved ? COLORS.success : isRejected ? COLORS.critical : undefined
        }
        icon={isResolved || isRejected ? faCircleCheck : faCircle}
      />{' '}
      <TrueImpactText>{section.section.label}</TrueImpactText>
    </StyledDiv>
  );
};

export default FeedbackTooltip;
